"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadcrumbIcon = exports.Breadcrumb = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require(".");

var _Typography = require("./Typography");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children"];

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var BreadcrumbIcon = _styledComponents["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

exports.BreadcrumbIcon = BreadcrumbIcon;

var RawBreadcrumb = function RawBreadcrumb(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return (0, _jsxRuntime.jsxs)(_.Box, _objectSpread(_objectSpread({
    as: "li",
    display: "inline-flex",
    mr: "3",
    alignItems: "center"
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)(_Typography.InlineBody, {
      color: "link",
      fontWeight: "bold",
      mr: "3",
      lineHeight: "16px",
      children: children
    }), (0, _jsxRuntime.jsx)(BreadcrumbIcon, {
      children: (0, _jsxRuntime.jsx)(_.Icon, {
        type: "arrow",
        width: "9px",
        height: "15px",
        verticalAlign: "middle"
      })
    })]
  }));
};

var Breadcrumb = (0, _styledComponents["default"])(RawBreadcrumb)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"])));
exports.Breadcrumb = Breadcrumb;